const url = new URL(window.location.href)
const pathname = url.pathname

const country = pathname.slice(4, 6)
const lang = pathname.slice(1, 3)

if(country === 'eu' && lang !== 'en') {
    const newUrl = '/'.concat('en', '-', country, pathname.slice(6, pathname.length))
    window.location.replace(newUrl) 
} else if(country === 'fr' && lang !== 'fr') {
    const newUrl = '/'.concat('fr', '-', country, pathname.slice(6, pathname.length))
    window.location.replace(newUrl) 
}